<ul>
    <li *ngFor="let product of products">{{ product.name }} costs {{ product.price }}</li>
</ul>


<!--<ul>-->
    <!--<li *ngFor="let user of users">{{ user.user_name }} has id {{ user.user_id }}</li>-->
<!--</ul>-->


<ul>
    <div *ngIf="user != null">
        {{user?.user_name}} has {{user?.user_id}}
    </div>
</ul>